import { connect } from 'react-redux'
import { hooks } from '@adc/ui-adc'
import analytics from '../services/analytics'
import '@adc/ui-adc/lib/styles.css'
import Router from 'common/components/router'
import { FeatureFlags } from '@adc/ui-adc'

const App = ({
  featureFlags,
  user,
}: {
  featureFlags: FeatureFlags
  user: any
}): JSX.Element => {
  hooks.useMountEffect(() => {
    analytics.initialize(user, featureFlags)
  })
  return <Router />
}

const mapStateToProps = (store: any) => {
  return {
    user: store.user,
    featureFlags: store.featureFlags,
  }
}

export default connect(mapStateToProps)(App)
export { App }
